import React,{Component} from 'react'
import PaperSheet from '../components/paper'
import {PropTypes as MobxPropTypes} from 'mobx-react';
import {observer} from 'mobx-react'
@observer
class SkillIntroduce extends Component{
    static contextTypes={
        store:MobxPropTypes.observableObject.isRequired
    }
    render(){
        let {skillIntoinfo} =this.context.store;
        return (
            <div className="App-main">
            <div className="side"></div>
            <div className="main">
                <PaperSheet prop={skillIntoinfo} />
            </div>
            <div className="side"></div>
            </div>
            
        )
    }
}
export default SkillIntroduce;


// WEBPACK FOOTER //
// ./src/skills/index.js